import React from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper } from './SectionWrapper';
const faqs = [{
  q: '¿Esto funciona si mi hijo es muy rebelde?',
  a: 'Sí, porque la INR no requiere que él coopere al principio; solo requiere que tú cambies la frecuencia de la señal.'
}, {
  q: '¿Voy a perder mi autoridad?',
  a: 'Al contrario, un padre que no pierde los estribos tiene mucha más autoridad real que uno que grita.'
}, {
  q: '¿Es un libro muy largo?',
  a: 'No. Está diseñado para padres ocupados. Son consejos directos a la vena que puedes leer en una sentada.'
}];
export function FAQSection() {
  return <SectionWrapper altBg data-id="element-33">
      <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-12 text-center" data-id="element-34">
        Preguntas Frecuentes
      </h2>

      <div className="space-y-6 max-w-2xl mx-auto" data-id="element-35">
        {faqs.map((faq, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: index * 0.1
      }} className="border-b border-subtle pb-6 last:border-0" data-id="element-36">
            <h3 className="text-xl font-heading font-semibold text-primary mb-3" data-id="element-37">
              {faq.q}
            </h3>
            <p className="text-secondary font-body leading-relaxed" data-id="element-38">{faq.a}</p>
          </motion.div>)}
      </div>
    </SectionWrapper>;
}